// Vendor Libs
import {combineReducers} from 'redux';
import {createReduxHistoryContext} from 'redux-first-history';
import {createBrowserHistory} from 'history';

// App Reducers
import auth from './auth-reducer';
import changePassword from './change-password-reducer';
import deleteData from './delete-data-reducer';
import deleteOffering from './delete-offering-reducer';
import deleteRecord from './delete-record-reducer';
import deleteRule from './delete-rule-reducer';
import deleteShell from './delete-shell-reducer';
import flaggedMetadata from './flagged-metadata-reducer';
import formData from './form-data-reducer';
import globalResponse from './global-response-reducer';
import graceNote from './grace-note-reducer';
import layout from './layout-reducer';
import mapping from './mapping-reducer';
import markerFingerprint from './marker-fingerprint-reducer';
import markerGeneration from './marker-generation-reducer';
import massActionData from './mass-action-data-reducer';
import networks from './network-reducer';
import overlays from './overlay-reducer';
import preferences from './preferences-reducer';
import recordLocking from './record-locking-reducer';
import requestPassword from './request-password-reducer';
import servicesActionData from './services-action-caller-reducer';
import servicesSearchData from './services-data-reducer';
import tabs from './tabs-reducer';
import router from './router-reducer';

export const reduxHistoryContext = createReduxHistoryContext({
    history: createBrowserHistory(),
    routerReducerKey: 'history',
});

const {routerReducer: history} = reduxHistoryContext;

const rootReducer = combineReducers({
    auth,
    changePassword,
    deleteData,
    deleteOffering,
    deleteRecord,
    deleteRule,
    deleteShell,
    flaggedMetadata,
    formData,
    globalResponse,
    graceNote,
    history,
    layout,
    mapping,
    markerFingerprint,
    markerGeneration,
    massActionData,
    networks,
    overlays,
    preferences,
    recordLocking,
    requestPassword,
    router,
    servicesActionData,
    servicesSearchData,
    tabs,
});

export default rootReducer;
